import React from "react";

const LANGS = ["JP", "EN", "ZH",];

export default function LanguageSwitcher({ language, setLanguage }) {
    return (
        <div className="flex items-center rounded-full overflow-hidden border border-[#b5435f] bg-white/80 backdrop-blur-sm shadow-sm">
            {LANGS.map((lang) => {
                const active = language === lang;
                return (
                    <button
                        key={lang}
                        onClick={() => setLanguage(lang)}
                        className={`px-3 py-2 text-xs font-bold transition-colors leading-none
                            ${active
                                ? "bg-[#b5435f] text-white"
                                : "text-gray-500 hover:text-gray-800 hover:bg-white"
                            }`}
                        style={{ minWidth: 36 }}
                    >
                        {lang}
                    </button>
                );
            })}
        </div>
    );
}
